import React, { useEffect, useState } from "react";
import { Amplify, Auth } from "aws-amplify";
import LoadingSpinner from "../common/loading";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import "./console.css";
import SchemaEditView from "../schema/schema-edit-view";
import SchemaManageView from "../schema/schema-manage-view";
import { developerAccessTokenState, originalPathState } from "../global-state";
import { useRecoilState } from "recoil";
import PlaygroundView from "../playground/playground-view";
import SchemaBrowseView from "../schema/schema-browse-view";
import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SchemaUploadView from "../schema/schema-upload-view";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CssBaseline from "@mui/material/CssBaseline";
import { DEV_AUTH_CONFIG } from "../aws-config";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LandingPage from "./landing-page";
import SchemaRagView from "../schema/schema-rag-view";
import WaitlistUsersView from "./waitlist";
import UiWidgetView from "../ui/ui-widget";
import StasticsView from "../statistics/statistics-view";
import ExecutionStasticsView from "../statistics/execution-statistics-view";
import AutomationStasticsView from "../statistics/automation-statistics-view";
import UserStasticsView from "../statistics/user-statistics-view";
import AssistantStasticsView from "../statistics/assistant-statistics-view";
import AssistantHistoryList from "../history/assistant-history-list";
import SkinConfig from "../skin/skin-config";
import QuickWordView from "../quickword/quick-word-view";
import PremadeScriptView from "../premade/premade-script-view";
import PremadeManageView from "../premade/premade-manage-view";
import PremadeSearchView from "../premade/premade-search-view";
import NotificationListView from "../notification/notification-list-view";
import Debug from "../debug/debug";
import ErrorScriptView from "../assistant/error-script-view";
import ModelView from "../assistant/model-view";
import CacheView from "../system/cache-view";

const drawerWidth = 240;

const routes = [
  {
    path: "/playground",
    exact: true,
    main: () => <PlaygroundView />,
  },
  {
    path: "/schema/browse",
    exact: true,
    main: () => <SchemaBrowseView />,
  },
  {
    path: "/schema/upload",
    exact: true,
    main: () => <SchemaUploadView />,
  },
  {
    path: "/schema/edit",
    exact: true,
    main: () => <SchemaEditView />,
  },
  {
    path: "/schema/manage",
    exact: true,
    main: () => <SchemaManageView />,
  },
  {
    path: "/schema/rag",
    exact: true,
    main: () => <SchemaRagView />,
  },
  {
    path: "/waitlist",
    exact: true,
    main: () => <WaitlistUsersView />,
  },
  {
    path: "/ui-widget",
    exact: true,
    main: () => <UiWidgetView />,
  },
  {
    path: "/statistics",
    exact: true,
    main: () => <StasticsView />,
  },
  {
    path: "/statistics/execution",
    exact: true,
    main: () => <ExecutionStasticsView />,
  },
  {
    path: "/statistics/automation",
    exact: true,
    main: () => <AutomationStasticsView />,
  },
  {
    path: "/statistics/user",
    exact: true,
    main: () => <UserStasticsView />,
  },
  {
    path: "/statistics/assistant",
    exact: true,
    main: () => <AssistantStasticsView />,
  },
  {
    path: "/assistant",
    exact: true,
    main: () => <AssistantHistoryList />,
  },
  {
    path: "/assistant/error-script",
    exact: true,
    main: () => <ErrorScriptView />,
  },
  {
    path: "/assistant/model",
    exact: true,
    main: () => <ModelView />,
  },
  {
    path: "/system/cache",
    exact: true,
    main: () => <CacheView />,
  },
  {
    path: "/skin-config",
    exact: true,
    main: () => <SkinConfig />,
  },
  {
    path: "/quick-word",
    exact: true,
    main: () => <QuickWordView />,
  },
  {
    path: "/premade/manage",
    exact: true,
    main: () => <PremadeManageView />,
  },
  {
    path: "/premade/search",
    exact: true,
    main: () => <PremadeSearchView />,
  },
  {
    path: "/notification",
    exact: true,
    main: () => <NotificationListView />,
  },
  {
    path: "/debug",
    exact: true,
    main: () => <Debug />,
  },
  {
    path: "/",
    exact: true,
    main: () => <LandingPage />,
  },
];

const ConsoleAppBar = ({ developer, onMenu }) => {
  const [devEl, setDevEl] = useState(null);
  const location = useLocation();
  const history = useHistory();

  const handleLogout = async () => {
    try {
      Amplify.configure(DEV_AUTH_CONFIG);
      await Auth.signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const handleDeveloperOpen = event => {
    setDevEl(event.currentTarget);
  };

  const handleDeveloperClose = () => {
    setDevEl(null);
  };

  const getTitle = () => {
    switch (location.pathname) {
      case "/playground":
        return "Device Playground";
      case "/waitlist":
        return "Waitlist";
      case "/schema/browse":
        return "Schema Browse";
      case "/schema/upload":
        return "Schema Upload";
      case "/schema/edit":
        return "Schema Edit";
      case "/schema/manage":
        return "Schema Manage";
      case "/schema/rag":
        return "Schema RAG";
      case "/ui-widget":
        return "Twin Schema";
      case "/statistics":
        return "Statistics";
      case "/statistics/execution":
        return "Execution Statistics";
      case "/statistics/automation":
        return "Automation Statistics";
      case "/statistics/user":
        return "User Statistics";
      case "/statistics/assistant":
        return "Assistant Statistics";
      case "/assistant":
        return "Assistant History";
      case "/assistant/error-script":
        return "Error Script";
      case "/assistant/model":
        return "Model Management";
      case "/system/cache":
        return "Cache Management";
      case "/skin-config":
        return "Twin Skin";
      case "/quick-word":
        return "Quick Commands";
      case "/premade/manage":
        return "Premade Manage";
      case "/premade/script":
        return "Premade Script";
      case "/premade/search":
        return "Premade Search";
      case "/notification":
        return "Notification Manager";
      case "/debug":
        return "Automation Debugger";
      default:
        return "Automation Console";
    }
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenu}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        {location.pathname.startsWith("/statistics/") && (
          <IconButton
            color="inherit"
            aria-label="overview"
            edge="start"
            sx={{ mr: 1 }}
            onClick={() => {
              history.push("/statistics");
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        {location.pathname.startsWith("/assistant/") && (
          <IconButton
            color="inherit"
            aria-label="overview"
            edge="start"
            sx={{ mr: 1 }}
            onClick={() => {
              history.push("/assistant");
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        {location.pathname === "/premade/script" && (
          <IconButton
            color="inherit"
            aria-label="overview"
            edge="start"
            sx={{ mr: 1 }}
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {getTitle()}
        </Typography>
        <div>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="dev-menu"
            aria-haspopup="true"
            onClick={handleDeveloperOpen}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="dev-menu"
            anchorEl={devEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(devEl)}
            onClose={handleDeveloperClose}
          >
            <MenuItem disabled>Hello, {developer}</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
};

const Console = () => {
  const [developerAuthState, setDeveloperAuthState] = useState(false);
  const [userName, setUserName] = useState("");
  const [originalPath, setOriginalPath] = useRecoilState(originalPathState);
  const [developerAccessToken, setDeveloperAccessToken] = useRecoilState(
    developerAccessTokenState,
  );
  const path = useLocation();
  const theme = useTheme();
  const [navOpen, setNavOpen] = useState(false);
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const [schemaCollapsed, setSchemaCollapsed] = useState(true);
  const [premadeCollapsed, setPremadeCollapsed] = useState(true);
  const [assistantCollapsed, setAssistantCollapsed] = useState(true);
  const [uiCollapsed, setUiCollapsed] = useState(true);
  const history = useHistory();

  useEffect(() => {
    checkDeveloperAuthState();
    const intervalId = setInterval(() => {
      console.log("Refresh token!");
      checkDeveloperAuthState();
    }, 10 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);

  const checkDeveloperAuthState = async () => {
    setOriginalPath(path.pathname + path.search + path.hash);
    try {
      Amplify.configure(DEV_AUTH_CONFIG);
      const session = await Auth.currentSession();
      const email = session.getIdToken().payload["cognito:username"];
      const accessToken = session.getAccessToken().getJwtToken();
      setDeveloperAccessToken(accessToken);
      setDeveloperAuthState(true);
      setUserName(email);
    } catch (error) {
      setDeveloperAuthState(false);
      console.log(error);
      history.push("/developer-login");
    }
  };

  const handleSchemaCollapsed = () => {
    setSchemaCollapsed(!schemaCollapsed);
  };
  const handlePremadeCollapsed = () => {
    setPremadeCollapsed(!premadeCollapsed);
  };

  const handleAssistantCollapsed = () => {
    setAssistantCollapsed(!assistantCollapsed);
  };

  const handleUiCollapsed = () => {
    setUiCollapsed(!uiCollapsed);
  };

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  const navPlayground = () => {
    history.push("/playground");
  };

  const navSchemaBrowse = () => {
    history.push("/schema/browse");
  };

  const navSchemaUpload = () => {
    history.push("/schema/upload");
  };

  const navSchemaManage = () => {
    history.push("/schema/manage");
  };

  const navSchemaRag = () => {
    history.push("/schema/rag");
  };

  const navWaitlist = () => {
    history.push("/waitlist");
  };

  const navUiWidget = () => {
    history.push("/ui-widget");
  };

  const navStatistics = () => {
    history.push("/statistics");
  };

  const navAssistantHistory = () => {
    history.push("/assistant");
  };

  const navErrorScript = () => {
    history.push("/assistant/error-script");
  };

  const navModelView = () => {
    history.push("/assistant/model");
  };

  const navSkinConfig = () => {
    history.push("/skin-config");
  };

  const navQuickWord = () => {
    history.push("/quick-word");
  };

  const navPremadeManage = () => {
    history.push("/premade/manage");
  };

  const navPremadeSearch = () => {
    history.push("/premade/search");
  };

  const navNotification = () => {
    history.push("/notification");
  };

  const navCacheView = () => {
    history.push("/system/cache");
  };

  const navDebug = () => {
    history.push("/debug");
  };

  const drawer = (
    <List
      sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <ListItemButton onClick={navPlayground}>
        <ListItemText primary="Playground" />
      </ListItemButton>
      <ListItemButton onClick={navWaitlist}>
        <ListItemText primary="Waitlist" />
      </ListItemButton>
      <ListItemButton onClick={handleSchemaCollapsed}>
        <ListItemText primary="Schema" />
        {schemaCollapsed ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={schemaCollapsed} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton sx={{ pl: 4 }} onClick={navSchemaBrowse}>
            <ListItemText primary="Browse" />
          </ListItemButton>
          <ListItemButton sx={{ pl: 4 }} onClick={navSchemaUpload}>
            <ListItemText primary="Upload" />
          </ListItemButton>
          <ListItemButton sx={{ pl: 4 }} onClick={navSchemaManage}>
            <ListItemText primary="Manage" />
          </ListItemButton>
          <ListItemButton sx={{ pl: 4 }} onClick={navSchemaRag}>
            <ListItemText primary="RAG" />
          </ListItemButton>
        </List>
      </Collapse>
      <ListItemButton onClick={navStatistics}>
        <ListItemText primary="Statistics" />
      </ListItemButton>
      <ListItemButton onClick={handleAssistantCollapsed}>
        <ListItemText primary="Assistant" />
        {assistantCollapsed ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={assistantCollapsed} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton sx={{ pl: 4 }} onClick={navAssistantHistory}>
            <ListItemText primary="History" />
          </ListItemButton>
          <ListItemButton sx={{ pl: 4 }} onClick={navErrorScript}>
            <ListItemText primary="Error Script" />
          </ListItemButton>
          <ListItemButton sx={{ pl: 4 }} onClick={navModelView}>
            <ListItemText primary="Model" />
          </ListItemButton>
        </List>
      </Collapse>
      <ListItemButton onClick={handleUiCollapsed}>
        <ListItemText primary="UI" />
        {uiCollapsed ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={uiCollapsed} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton sx={{ pl: 4 }} onClick={navUiWidget}>
            <ListItemText primary="Twin Schema" />
          </ListItemButton>
          <ListItemButton sx={{ pl: 4 }} onClick={navSkinConfig}>
            <ListItemText primary="Twin Skin" />
          </ListItemButton>
        </List>
      </Collapse>
      <ListItemButton onClick={navQuickWord}>
        <ListItemText primary="Quick Commands" />
      </ListItemButton>
      <ListItemButton onClick={navDebug}>
        <ListItemText primary="Debug Automation" />
      </ListItemButton>
      <ListItemButton onClick={handlePremadeCollapsed}>
        <ListItemText primary="Premade" />
        {premadeCollapsed ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={premadeCollapsed} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton sx={{ pl: 4 }} onClick={navPremadeManage}>
            <ListItemText primary="Manage" />
          </ListItemButton>
          <ListItemButton sx={{ pl: 4 }} onClick={navPremadeSearch}>
            <ListItemText primary="Search" />
          </ListItemButton>
        </List>
      </Collapse>
      <ListItemButton onClick={navNotification}>
        <ListItemText primary="Notification" />
      </ListItemButton>
      <ListItemButton onClick={navCacheView}>
        <ListItemText primary="Cache Management" />
      </ListItemButton>
    </List>
  );

  return (
    <div>
      {!developerAuthState ? (
        <LoadingSpinner />
      ) : (
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <ConsoleAppBar developer={userName} onMenu={toggleNav} />
          <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
          >
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: "none", sm: "block" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                },
              }}
              open
            >
              {drawer}
            </Drawer>
            <Drawer
              variant={isLargeScreen ? "permanent" : "temporary"}
              open={isLargeScreen ? true : navOpen}
              onClose={toggleNav}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: "block", sm: "none" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                },
              }}
            >
              {drawer}
            </Drawer>
          </Box>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >
            <Toolbar />
            <Switch>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  component={route.main}
                />
              ))}
            </Switch>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default Console;
